import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {SectionSubTitle} from "../../CummonComponents/SectionSubTitle/SectionSubTitle";
import {Container, Img, Item, List,Link, Text, Wrap} from "./styled";
import {useImageUrl} from "../../../queries";

const ResourceItem = ({resource}) => {
    const fileUrl = useImageUrl(resource?.file);

    if (!resource) {
        return null;
    }

    return (
        <Item>
            <Link href={fileUrl || '#'} target="_blank" rel="noopener noreferrer">
                <Img width={75} height={75} src={'./img/pdf.jpg'} alt={resource?.description}/>
                {resource?.title}
            </Link>
            <Text>{resource?.description}</Text>
        </Item>
    );
};

export const Publications = ({data}) => {
    if (!data) {
        return null;
    }

    return(
        <Container>
            <Wrap>
                <SectionTitle>{data?.content_title}</SectionTitle>
                <SectionSubTitle>
                    {data?.content_description}
                </SectionSubTitle>
                <List>
                    {data?.resources && data.resources.map((resource) => {
                        const resourceItem = resource?.item || resource;
                        return (
                            <ResourceItem
                                key={resourceItem?.id}
                                resource={resourceItem}
                            />
                        );
                    })}
                </List>
            </Wrap>
        </Container>
    )
}
